import { Utils } from '@sbs/uikit-constructor';
import { ACTIVITY_BLOCK_TYPES } from '@/constants/index.js';

export const createQuoteItem = (content = {}) => ({
    id: Utils.Helpers.getRandomId(),
    attributes: {
        type: `${ACTIVITY_BLOCK_TYPES.Quote}Item`,
    },
    content: {
        text: '',
        image: null,
        title: '',
        description: '',
        ...content,
    },
});
